import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

import useContextsAnalytics from "../useContextsAnalytics";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction({ trackAnalytics: useContextsAnalytics() })(props);
};

export default useCellCopyAction;
